

export default function ErrorBoundaryPage() {
 // const error = useRouteError();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center ">
      <div className="flex flex-col items-center">
        <svg className="mx-auto mb-4 w-16 h-16 text-btn-red" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01" />
        </svg>
        <h1 className="text-3xl font-bold text-btn-red mb-2">Oops! Something went wrong.</h1>
        <p>Please try reloading the page</p>
        <button className="mt-4 px-6 py-2 bg-btn-red text-white rounded hover:bg-red-400 transition" onClick={() => window.location.reload()}>
          Reload Page
        </button>
      </div>
    </div>
  );
}
